module.exports = "pegasus/assets/graycircle-pinterest.png";